import { GROUP_MEMBER_ROLES, GROUP_MEMBER_STATUS } from "constants/roles";

export function getMemberGroupRole(memberRole) {
    return GROUP_MEMBER_ROLES[memberRole]
}

export function getMemberGroupStatus(memberStatus) {
    return GROUP_MEMBER_STATUS[memberStatus]
}